import { render, staticRenderFns } from "./SportsGames.vue?vue&type=template&id=a30a595a&"
import script from "./SportsGames.vue?vue&type=script&lang=js&"
export * from "./SportsGames.vue?vue&type=script&lang=js&"
import style0 from "./SportsGames.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports